module.exports = __webpack_public_path__ + "static/media/wordZendy.2f645869.png";